import $ from "jquery";
import { isNullOrUndefined } from 'util';
import withCart from '../General/withCart';
import { AbconetApi } from '../General/AbconetApi';


class ProductCard extends React.Component {

    constructor(props) {
        super(props);
        var amount = "";
        var inCurrentOrder = false;

        if (props.cartItem) {
            amount = props.cartItem.quantity;
            inCurrentOrder = true;
        }

        this.state = {
            amount: amount,
            inCurrentOrder: inCurrentOrder,
            isSaving: false,
            isSynced: true
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.cartItem && this.state.amount !== this.props.cartItem.quantity) {
            this.setState({
                amount: this.props.cartItem.quantity,
                inCurrentOrder: true
            });

        }
    }

    updateCart(ev) {
        ev.preventDefault();

        var self = this;
        this.setState({ isSaving: true });
        AbconetApi.post(`/api/cart/stockcode/${this.props.item.stockcode}`, this.state.amount).then(function (cart) {
            $(document).trigger("CartUpdated", cart);
            self.setState({
                isSynced: true,
                inCurrentOrder: true,
                isSaving: false
            });
        });
    }

    updateAmount(ev) {
        if (ev.target.value <= 0) {
            this.setState({
                amount: 1,
                isSynced: false
            });
        } else {
            this.setState({
                amount: ev.target.value,
                isSynced: false
            });
        }
        
    }

    renderInStock() {
        if (isNullOrUndefined(this.props.cart) || isNullOrUndefined(this.props.cart.supplyLocation)) {
            return;
        }

        if (this.props.cart && this.props.item.stockAvailability) {
            var currentLocation = this.props.item.stockAvailability.filter((location) => {
                return this.props.cart.supplyLocation == location.locationName;
            });

            if (isNullOrUndefined(currentLocation[0]) || isNullOrUndefined(currentLocation[0].status)) {
                return;
            }

            var className;
            var text;
            switch (currentLocation[0].status) {
                case "InStock":
                    className = "in-stock";
                    text = "In Stock";
                    break;
                case "LowStock":
                    className = "low-stock";
                    text = "Only " + currentLocation[0].amount + " left";
                    break;
                case "OutOfStock":
                    className = "out-stock";
                    text = "Out of stock";
                    break;
            }           
            
            if (currentLocation.length > 0 && currentLocation[0].status != "InStock") {
                return <span className={"stock-availability " + className}>{text}</span>;
            }
        }
    }

    renderAddToOrderButton() {

        var btnClass = 'changes';
        var disabled = false;

        var buttonText = "Add to order";
        if (this.state.inCurrentOrder) {
            buttonText = "Update";
        }

        if (this.state.isSaving) {
            disabled = true;
            buttonText = "Updating";
            btnClass = 'saving';
        }

       
        if (isNullOrUndefined(this.state.amount) || this.state.isSynced ) {
            disabled = true;
        }

        return <button href="#" className={"btn btn-primary add-to-order float-right " + btnClass} disabled={disabled} onClick={this.updateCart.bind(this)}>{buttonText}</button>;
    }

    renderEditCartOptions() {
        if (!this.props.canAddToCart) {
            return;
        }

        if (this.props.limitOrderToApprovedStocklist && this.props.item.isApprovedStocklist == false) {
            return;
        }

        if (this.props.limitOrderToTemplateStocklist && this.props.item.isTemplateStocklist == false) {
            return;
        }

        return [
            <div key={"addToCartContainer"} className="col-4">
                <input className="form-control add-item" type="number" onChange={this.updateAmount.bind(this)} value={this.state.amount} />
            </div>,
            <div key={"actionsContainer"} className="col-7">
                {this.renderAddToOrderButton()}
            </div>
        ];
    }

    renderPrice() {
        if (this.props.item.bestPrice > 0) {
            return <div className="col-12">
                <span className="price">${this.props.item.bestPrice.toFixed(2)}</span>
            </div>;
        }
    }

    render() {

        var size = this.props.item.imageFileName == 'no-image.svg' ? '40' : '';
        return (
            <div key={this.props.item.stockcode} className="item-card">
                <a href={this.props.item.url} className="image-container"><img src={this.props.item.imageFileName} className="product-image" width={size} /></a>
                <p className="description"><a href={this.props.item.url}>{this.props.item.name}</a></p>


                <div className="row product-information">
                    <div className="col-12">
                        <span className="stockcode">Code: {this.props.item.stockcode}</span>
                        {this.renderInStock()} 
                    </div>

                    {this.renderPrice()}
                    {this.renderEditCartOptions()}
                </div>
            </div>
            );
}

}

export default withCart(ProductCard);